import React, { useState } from "react";

import { useTranslation } from "react-i18next";
import "./styles.less";

export const Card = (props) => {
  const { title, subtitle, img } = props;

  return (
    <div className="zero-card">
      <div className="img">
        <img src={`//files.authing.co/authing-website/${img}`} alt="" />
      </div>
      <div className="title">{title}</div>
      <div className="subtitle">{subtitle}</div>
    </div>
  );
};

export const ZeroAdvantage = (props) => {
  const { t } = useTranslation();
  const CardData = [
    {
      img: "zero-trust-advantage-1.png",
      title: t("zeroTrust.advantage.item1.title"),
      subtitle: t("zeroTrust.advantage.item1.subtitle"),
    },
    {
      img: "zero-trust-advantage-2.png",
      title: t("zeroTrust.advantage.item2.title"),
      subtitle: t("zeroTrust.advantage.item2.subtitle"),
    },
    {
      img: "zero-trust-advantage-3.png",
      title: t("zeroTrust.advantage.item3.title"),
      subtitle: t("zeroTrust.advantage.item3.subtitle"),
    },
    {
      img: "zero-trust-advantage-4.png",
      title: t("zeroTrust.advantage.item4.title"),
      subtitle: t("zeroTrust.advantage.item4.subtitle"),
    },
  ];
  return (
    <div>
      <section className="zero-trust-advantage">
        <div className="inner">
          <div className="title">{t("zeroTrust.advantage.title")}</div>
          <div className="subtitle">{t("zeroTrust.advantage.subtitle")}</div>
          <div className="zero-card-warp">
            {CardData.map((item) => (
              <Card {...item} />
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};
